import type { ICountry } from '@/interfaces'

export class Country implements ICountry {
	code: string
	name: string
	constructor({ code, name }: ICountry) {
		this.code = code
		this.name = name
	}
}
